import { Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

type Props = {
  onChange: () => void;
  onCreate: () => void;
  createDisabled?: boolean;
  createLoading?: boolean;
};

export const RenderingsMobilePreviewActions = ({
  onChange,
  onCreate,
  createDisabled,
  createLoading,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className="z-20 shrink-0 border-t border-slate-200 bg-white px-4 py-3">
      <div className="flex gap-3">
        <Button
          type="button"
          variant="outline"
          className="h-11 flex-1 rounded-sm text-base font-semibold"
          onClick={onChange}
        >
          {t('change')}
        </Button>
        <Button
          type="button"
          className="h-11 flex-1 gap-2 rounded-sm text-base font-semibold"
          disabled={createDisabled || createLoading}
          onClick={onCreate}
        >
          <Sparkles aria-hidden className="size-5" />
          {t('create')}
        </Button>
      </div>
    </div>
  );
};
